// @flow
import * as React from 'react';
import type { SvgComponentProps } from '~/core/icons/svg-icons/types';

const Info = ({ fill, svgComponents: { G, Path, Rect } }: SvgComponentProps) => {
    const gProps = fill ? { fill } : {};
    return (
        <G {...gProps}>
            <Path d="M20,36A16,16,0,1,1,36,20,16,16,0,0,1,20,36ZM20,5A15,15,0,1,0,35,20,15,15,0,0,0,20,5Z" />
            <Rect height="3" rx="1.5" ry="1.5" width="3" x="18.5" y="11.13" />
            <Path d="M20,29.38a.5.5,0,0,1-.5-.5v-12a.5.5,0,0,1,1,0v12A.5.5,0,0,1,20,29.38Z" />
        </G>
    );
};

export default Info;



// WEBPACK FOOTER //
// ./src/core/icons/svg-icons/general/info/index.js